import { render, staticRenderFns } from "./GlobalRecorderControl.vue?vue&type=template&id=963e7eb0&scoped=true"
import script from "./GlobalRecorderControl.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalRecorderControl.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GlobalRecorderControl.vue?vue&type=style&index=0&id=963e7eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963e7eb0",
  null
  
)

export default component.exports